module.exports = __webpack_public_path__ + "media/tape-nav/commerce-university-icon-7d33f047.svg";